import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/coolblue.webp';
import screenshot_target from '../../../images/letterfunnel/pieterzwart.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="CTOfull_asdfoijaspdoifj"
      firstname="CTOfirst_asdfasdf"
      companyname="CTOCOMPANPOASDFOIJE"
      competition="CTOAmazonenBol"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/_exampleCTO.js